/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Flex, Text, Box } from '@tishman/components';
import { H } from '@hzdg/sectioning';
import React from 'react';

export interface CategoryHeaderProps {
  carouselTitle: string;
  description: React.ReactNode;
}

export function CategoryHeader({
  carouselTitle,
  description,
}: CategoryHeaderProps): JSX.Element | null {
  if (!carouselTitle && !description) {
    return null;
  }

  return (
    <Flex
      px={[3, 4]}
      sx={{
        flexDirection: ['column'],
        justifyContent: ['space-between'],
        alignItems: ['flex-start'],
        mb: '33px',
        position: 'relative',
        flex: '0 0 80%',
      }}
    >
      {carouselTitle && (
        <H
          sx={{
            variant: 'styles.h1',
            fontSize: [6, null, null, 7],
            fontFamily: 'headingSecondary',
            mb: '15px',
            pr: '84px',
          }}
        >
          {carouselTitle}
        </H>
      )}

      <Box
        as="div"
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        {description && (
          <Text
            sx={{
              p: {
                marginBottom: 0,
              },
            }}
            variant="smallP"
          >
            {description}
          </Text>
        )}
      </Box>
    </Flex>
  );
}
